import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import useNotifier from "@saleor/hooks/useNotifier";
import { useCancelAutoBooking } from "@saleor/motherOrders/mutations";
import React, { FC } from "react";

const useStyles = makeStyles(
  theme => ({
    btnCloseIcon: {
      marginLeft: "90%"
    },
    btnGray: {
      "&:hover": {
        backgroundColor: theme.palette.grey[500]
      },
      backgroundColor: theme.palette.grey[500]
    },
    btnPrimary: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main
    },
    buttonActionCenter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: 20,
      marginTop: 20
    },
    centerContent: {
      fontWeight: 500,
      padding: 10,
      textAlign: "center"
    },
    divFlexCentered: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20
    },
    marginRight20: {
      marginRight: "20px"
    },
    templateDialogTitle: {
      fontSize: 20,
      fontWeight: 700,
      marginLeft: 2
    },
    textWhite: {
      color: "#FFF"
    }
  }),
  { name: "GrabCancelAutobookingModal" }
);

export interface GrabCancelAutobookingModalProps {
  orderId: string;
  displayDialog: boolean;
  onClose: () => void;
  onSaved?: () => void;
  title: string;
  content: string;
  isForSavingCancelAutobooking: boolean;
}

const GrabCancelAutobookingModal: FC<GrabCancelAutobookingModalProps> = props => {
  const {
    orderId,
    displayDialog,
    onClose,
    onSaved,
    title,
    content,
    isForSavingCancelAutobooking
  } = props;

  const classes = useStyles(props);
  const notify = useNotifier();

  const [cancelAutobooking, cancelAutobookingOpts] = useCancelAutoBooking({
    onCompleted: data => {
      if (data.cancelAutoBooking.autoBookingError.length > 0) {
        data.cancelAutoBooking.autoBookingError.forEach(error => {
          notify({
            status: "error",
            text: error.message
          });
        });
      } else {
        onSaved();
      }
    },
    onError: errors => {
      const [error] = errors.graphQLErrors;
      notify({
        status: "error",
        text: error?.message
      });
    }
  });

  const handleSave = () => {
    if (isForSavingCancelAutobooking) {
      cancelAutobooking({
        variables: {
          orderId
        }
      });
    } else {
      onSaved();
    }
  };

  return (
    <Dialog
      open={displayDialog}
      maxWidth="xs"
      aria-labelledby="grab-cancel-autobooking-modal-title"
      aria-describedby="grab-cancel-autobooking-modal"
    >
      <DialogContent>
        <div className={classes.btnCloseIcon}>
          <CloseIcon onClick={onClose} />
        </div>
        <DialogContentText id="grab-cancel-autobooking-modal">
          <div className={classes.divFlexCentered}>
            <Typography className={classes.templateDialogTitle} variant="h5">
              {title}
            </Typography>
          </div>

          <div className={classes.centerContent}>{content}</div>

          <div className={classes.buttonActionCenter}>
            <Button
              color="inherit"
              variant="contained"
              className={`${classes.marginRight20} ${classes.btnGray}`}
              onClick={onClose}
            >
              <Typography className={classes.textWhite}>NO</Typography>
            </Button>
            <Button
              color="inherit"
              variant="contained"
              className={classes.btnPrimary}
              onClick={handleSave}
              disabled={cancelAutobookingOpts.loading}
            >
              <Typography className={classes.textWhite}>YES</Typography>
            </Button>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default GrabCancelAutobookingModal;
